import { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AIChatContext = createContext();

// Page-specific suggestions
const PAGE_SUGGESTIONS = {
  '/marketplace/cars': {
    ar: 'هل تريد مساعدتك في اختيار السيارة المثالية؟ 🚗',
    en: 'Need help choosing the perfect car? 🚗'
  },
  '/market/cars': {
    ar: 'هل تريد مساعدتك في اختيار السيارة المثالية؟ 🚗',
    en: 'Need help choosing the perfect car? 🚗'
  },
  '/marketplace/plates': {
    ar: 'هل تريد مني اساعدك على اختيار لوحة مميزة؟ 🔢',
    en: 'Want me to help you choose a special plate? 🔢'
  },
  '/market/plates': {
    ar: 'هل تريد مني اساعدك على اختيار لوحة مميزة؟ 🔢',
    en: 'Want me to help you choose a special plate? 🔢'
  },
  '/marketplace/numbers': {
    ar: 'هل تريد مساعدتك في اختيار رقم مميز؟ 📱',
    en: 'Need help choosing a special number? 📱'
  },
  '/market/numbers': {
    ar: 'هل تريد مساعدتك في اختيار رقم مميز؟ 📱',
    en: 'Need help choosing a special number? 📱'
  },
  '/real-estate': {
    ar: 'هل تبحث عن عقار مناسب؟ دعني أساعدك! 🏠',
    en: 'Looking for the right property? Let me help! 🏠'
  },
  '/services/company-formation': {
    ar: 'هل تريد تأسيس شركة في الإمارات؟ أنا خبير في هذا! 🏢',
    en: 'Want to start a company in UAE? I\'m an expert! 🏢'
  },
  '/services/visa': {
    ar: 'هل تحتاج مساعدة في التأشيرات والإقامة؟ ✈️',
    en: 'Need help with visas and residency? ✈️'
  },
  '/services/translation': {
    ar: 'هل تحتاج ترجمة قانونية معتمدة؟ 📄',
    en: 'Need certified legal translation? 📄'
  },
  '/services': {
    ar: 'استكشف خدماتنا! كيف أقدر أساعدك اليوم؟ ⭐',
    en: 'Explore our services! How can I help today? ⭐'
  },
  '/marketplace': {
    ar: 'مرحباً بك في السوق! ماذا تبحث عنه؟ 🛒',
    en: 'Welcome to the market! What are you looking for? 🛒'
  }
};

export function AIChatProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [notification, setNotification] = useState(null);
  const [lastNotifiedPath, setLastNotifiedPath] = useState('');
  const [notificationDismissed, setNotificationDismissed] = useState({});

  const [pendingPrompt, setPendingPrompt] = useState(null);

  const openChat = (prompt) => {
    if (typeof prompt === 'string' && prompt.trim()) setPendingPrompt(prompt.trim());
    setIsOpen(true);
  };
  const consumePendingPrompt = () => {
    const p = pendingPrompt;
    setPendingPrompt(null);
    return p;
  };
  const closeChat = () => setIsOpen(false);
  const toggleChat = () => setIsOpen(prev => !prev);
  
  const showNotification = (message, path) => {
    if (!notificationDismissed[path] && path !== lastNotifiedPath) {
      setNotification(message);
      setLastNotifiedPath(path);
      // Auto-hide after 8 seconds
      setTimeout(() => {
        setNotification(null);
      }, 8000);
    }
  };

  const dismissNotification = (path) => {
    setNotification(null);
    if (path) {
      setNotificationDismissed(prev => ({ ...prev, [path]: true }));
    }
  };

  const getPageSuggestion = (pathname, language) => {
    const suggestion = PAGE_SUGGESTIONS[pathname];
    if (suggestion) {
      return language === 'ar' ? suggestion.ar : suggestion.en;
    }
    return null;
  };

  return (
    <AIChatContext.Provider value={{ 
      isOpen, 
      openChat, 
      closeChat, 
      toggleChat, 
      setIsOpen,
      pendingPrompt,
      consumePendingPrompt,
      notification,
      showNotification,
      dismissNotification,
      getPageSuggestion,
      PAGE_SUGGESTIONS
    }}>
      {children}
    </AIChatContext.Provider>
  );
}

export function useAIChat() {
  const context = useContext(AIChatContext);
  if (!context) {
    throw new Error('useAIChat must be used within an AIChatProvider');
  }
  return context;
}

export default AIChatContext;
